<template>
  <v-container fluid class="container-alert">
    <v-layout justify-start column fill-height mb-4>
      <v-tabs slot="extension" v-model="tabIndex" color="dark" dark id="menu-condition">
        <v-tabs-slider color="yellow" />
        <v-tab
          v-for="item in tabMenu"
          :key="item"
          style="text-transform: none;"
        >{{ item }}</v-tab>
      </v-tabs>
    </v-layout>
    <!-- <v-layout lg md12>
      <v-flex text-lg-right>
        <v-btn @click="addAlert">
            <v-icon dark class="mr-2">
                add_alert
            </v-icon>
            <span id='btn-box-inside'>Create Alert</span>
        </v-btn>
      </v-flex>
    </v-layout> -->
    <v-layout lg12 md12>
      <!-- Confirm Delete -->
      <v-dialog v-model="deletemode" max-width="210px">
        <v-layout justify-center>
          <v-card>
            <v-card-title>
              Confirm Delete
            </v-card-title>
            <v-card-actions>
              <v-btn color="primary" dark @click="deleteRule()">confirm</v-btn>
              <v-btn color="grey darken-1" dark @click="deletemode=false">cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-dialog>
      <!-- table -->
      <v-layout column justify-center>
        <v-flex text-lg-right mb-4>
          <v-btn v-if="this.role === 'user'" @click="addAlert" style="outline: none;" id="btn-createAl">
              <v-icon dark class="mr-2">
                  add_alert
              </v-icon>
              <span id='btn-box-inside'>Create Alert</span>
          </v-btn>
          <v-btn v-else @click="createAlertForManagement" style="outline: none;" :loading="loadingBTN">
              <v-icon dark class="mr-2">
                  add_alert
              </v-icon>
              <span id='btn-box-inside'>Create Alert</span>
          </v-btn>
        </v-flex>
        <v-flex lg12 md12>
          <v-card dark v-if="this.role === 'user'">
            <v-card-title>
              Alert Condition Table
              <v-spacer/>
              <v-spacer/>
              <v-spacer/>
              <v-flex lg1 md1 style="top: 10px; position: relative; margin-right: 20px;">
                <v-select
                  v-model="device"
                  :items="devices"
                  label="Device"
                />
              </v-flex>
              <v-text-field v-model="search"
                            label="Search"
                            single-line
                            append-icon="search"
                            hide-details/>
            </v-card-title>
            <v-flex left md2 ml-3>
              <v-btn
                slot="activator"
                color="red lighten-2"
                :disabled="selected.length == 0"
                style="text-transform: none !important; outline: none;"
                dark
                round
                small
                @click="deleteSelectedAlert"
              >
              <v-icon size="22">delete</v-icon>
                Delete selected
              </v-btn>
            </v-flex>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="alert"
              :pagination.sync="pagination"
              :search="search"
              :custom-filter="customFilter"
              select-all
              item-key="_id"
              class="elevation-1"
              :loading="loadTable"
              id="ex-data"
              dark
            >
              <v-progress-linear slot:progress color="blue" indeterminate></v-progress-linear>
              <template v-slot:headers="props">
                <tr>
                  <th>
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      disabled
                      hide-details
                      @click.stop="toggleAll"
                    ></v-checkbox>
                  </th>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                    @click="changeSort(header.value)"
                  >
                    <v-icon small>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <!-- <tr :active="props.selected" @click="props.selected = !props.selected"> -->
                <tr>
                  <td>
                    <!-- <v-checkbox
                      :input-value="props.selected"
                      primary
                      hide-details
                    ></v-checkbox> -->
                    <v-checkbox
                      v-model="props.selected"
                      primary
                      hide-details
                    />
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td class="text-xs-center">{{ props.item.query }}</td>
                  <td class="text-xs-center">{{ props.item.selectedIndex }}</td>
                  <td class="text-xs-center">{{ props.item.eventTrigger }}</td>
                  <td class="text-xs-center">{{ props.item.trigger }}</td>
                  <td class="text-xs-center">{{ props.item.intervals }}</td>
                  <td class="text-xs-center">{{ props.item.action }}</td>
                  <td class="text-xs-center">{{ props.item.email }}</td>
                  <td class="justify-center layout px-0" id="table-action">
                    <v-icon small class="mr-2"
                            @click="geteditRule(props.item)">
                      build
                    </v-icon>
                    <v-icon small class="mr-2"
                            @click="getiduser(props.item)">
                      delete_outline
                    </v-icon>
                  </td>
                </tr>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </v-card>
          <v-card dark v-if="this.role === 'management'">
            <v-card-title>
              Alert Condition Table
              <v-spacer/>
              <v-spacer />
              <v-spacer />
              <v-flex lg1 md1 style="top: 10px; position: relative; margin-right: 20px;">
                <v-select
                  v-model="device"
                  :items="devices"
                  label="Device"
                />
              </v-flex>
              <v-text-field v-model="search"
                            label="Search"
                            single-line
                            append-icon="search"
                            hide-details/>
            </v-card-title>
            <v-flex left md2 ml-3>
              <v-btn
                slot="activator"
                color="red lighten-2"
                :disabled="selected.length == 0"
                style="text-transform: none !important; outline: none;"
                dark
                round
                small
                @click="deleteSelectedAlert"
              >
              <v-icon size="22">delete</v-icon>
                Delete selected
              </v-btn>
            </v-flex>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="alert"
              :pagination.sync="pagination"
              :search="search"
              :custom-filter="customFilter"
              select-all
              item-key="_id"
              class="elevation-1"
              :loading="loadTable"
              dark
            >
            <v-progress-linear slot:progress color="blue" indeterminate></v-progress-linear>
              <template v-slot:headers="props">
                <tr>
                  <th>
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      hide-details
                      disabled
                      @click.stop="toggleAll"
                    ></v-checkbox>
                  </th>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                    @click="changeSort(header.value)"
                  >
                    <v-icon small>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <!-- <tr :active="props.selected" @click="props.selected = !props.selected"> -->
                <tr>
                  <td>
                    <!-- <v-checkbox
                      :input-value="props.selected"
                      primary
                      hide-details
                    ></v-checkbox> -->
                    <v-checkbox
                      v-model="props.selected"
                      primary
                      hide-details
                    />
                  </td>
                  <td>{{ props.item.username }}</td>
                  <td class="text-xs-center">{{ props.item.name }}</td>
                  <td class="text-xs-center">{{ props.item.query }}</td>
                  <td class="text-xs-center">{{ props.item.selectedIndex }}</td>
                  <td class="text-xs-center">{{ props.item.eventTrigger }}</td>
                  <td class="text-xs-center">{{ props.item.trigger }}</td>
                  <td class="text-xs-center">{{ props.item.intervals }}</td>
                  <td class="text-xs-center">{{ props.item.action }}</td>
                  <td class="text-xs-center">{{ props.item.email }}</td>
                  <td class="justify-center layout px-0">
                    <v-icon small class="mr-2"
                            @click="geteditRule(props.item)">
                      build
                    </v-icon>
                    <v-icon small class="mr-2"
                            @click="getiduser(props.item)">
                      delete_outline
                    </v-icon>
                  </td>
                </tr>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
    <!-- <v-layout>
      <v-dialog
        :disabled="selected.length == 0"
        v-model="multiDelete"
        width="500"
      >

        <v-btn
          slot="activator"
          color="red lighten-2"
          dark
        >
          Delete
        </v-btn>

        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title
          >
            Confirm delete??
          </v-card-title>

          <v-card-text>
            You won't be able to revert back.
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#FF0000"
              flat
              @click="deleteItem"
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout> -->
    <!-- <v-flex>
      <v-btn slot="activator" flat icon dark @click.native="addAlert">
        <v-tooltip bottom>
          <v-icon style="font-size: 50px" slot="activator">add_circle</v-icon>
          <span>Add Alert</span>
        </v-tooltip>
      </v-btn>
    </v-flex> -->
    <v-dialog v-model="editalert"  persistent max-width="500px" min-height="450px">
      <loading :active.sync="editAlertLoading"
        :can-cancel="false"
      />
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-card dark>
          <v-toolbar flat>
            <v-toolbar-title>{{header}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click.native="editalert = false" icon style="outline: none;">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <!-- <v-card-title>
            {{header}}
          </v-card-title> -->
          <v-card-text>
            <v-text-field
              v-model="newAlertName"
              label="Alert Name"
              :rules="[v => !!v || 'Alert Name is required']"
              required
            />
            <v-combobox
              v-model="querytext"
              label="Query by (e.g. facebook)"
              chips
              clearable
              multiple
              :rules="queryRule"
            >
              <template slot="selection" slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  close
                  @input="remove(data.item)"
                >
                  <strong>{{ data.item }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-combobox>
            <v-select
              v-model="selectedIndex"
              label="Device"
              :items="deviceItem"
              :rules="[v => !!v || 'Device is required']"
            />
            <v-flex xs12 sm12 d-flex>
              <v-select
                v-model="eventTrigger"
                label="Event Type"
                :items="eventType"
                :rules="[v => !!v || 'Event Type is required']"
              />
            </v-flex>
            <v-flex v-if="eventTrigger === 'count'" lg12 md12 xs12 sm12 d-flex>
              <v-autocomplete
                v-if="eventTrigger"
                v-model="targetField"
                :items="dashField"
                :rules="[v => !!v || 'Select Field is required']"
                label="Select Field To Use Alert"
              />
            </v-flex>
            <v-flex xs12 sm12 d-flex v-if="eventTrigger === 'count'">
              <v-select
                v-model="alertTrigger"
                label="Trigger Alert When"
                :items="alertConditionOptions"
                :rules="[v => !!v || 'Trigger Alert When is required']"
              />
              <v-text-field
                v-model="number"
                label="Number of Results"
                type="Number"
                :rules="rulesnumber"
                required
              />
            </v-flex>
            <v-flex lg12 md12 xs12 sm12 d-flex v-else-if="eventTrigger === 'upload' || eventTrigger === 'download'">
              <v-select
                v-model="fieldalet"
                label="Select Field To Use Alert BW"
                :items="dashField"
                :rules="[v => !!v || 'Trigger Alert When is required']"
              />
            </v-flex>
            <v-flex lg12 md12 xs12 sm12 d-flex v-if="fieldalet">
              <v-flex lg5 md5>
                <v-select
                  v-model="alertTrigger"
                  label="Trigger Alert When"
                  :items="alertConditionOptions"
                  :rules="[v => !!v || 'Trigger Alert When is required']"
                />
              </v-flex>
              <v-text-field
                v-model="number"
                label="Number of Results"
                :rules="rulesnumber"
                type="Number"
                required
              />
              <v-flex lg2 md2>
                <v-select
                  v-model="unit"
                  label="Unit"
                  :items="units"
                  :rules="[v => !!v || 'Unit is required']"
                />
              </v-flex>
            </v-flex>
            <v-flex xs16 sm13 d-flex>
              <v-select
                v-model="alertInterval"
                label="Unit"
                :items="IntervalTime"
                :rules="rulestime"
              />
              <v-select
                v-model="intervals"
                label="Run Every"
                :items="alertFrequencyOptions"
                :rules="[v => !!v || 'Run Every is required']"
              />
            </v-flex>
            <v-flex xs16 sm13 d-flex>
              <VueCtkDateTimePicker
                v-if="alertInterval==='d'"
                v-model="yourValue"
                formatted="HH:mm"
                format="HH:mm"
                time-format="HH:mm"
                label="Choose time"
                :minute-interval="1"
                disable-date
                />
            </v-flex>
            <v-select
              v-model="Action"
              label="Action"
              :items="ActionType"
              :rules="[v => !!v || 'Action is required']"
              required
            />
            <v-text-field
              v-model="email"
              label="Sent to (Email)"
              :rules="[v => !!v || 'Email is required',
                      v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid']"
              required
            />
          </v-card-text>
          <v-card-actions>
            <!-- <v-btn v-if="this.method === 'add' || this.method === 'test'" right-5 class="red" @click="editRule('test')">
              Test Alert
            </v-btn> -->
            <v-btn
              light
              class="grey lighten-2 font-weight-regular"
              @click="editRule('test')"
              style="outline: none; text-transform: none; font-size: 16px; border-radius: 4px;"
            >
              Test Alert
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="this.method === 'add'"
              slot="activator"
              id="btn-create-submit"
              color="blue darken-3 font-weight-light"
              @click="editRule('add')"
              style="outline: none; text-transform: none; font-size: 16px; border-radius: 4px;"
            >
              <!-- <v-icon large>arrow_forward</v-icon> -->
              Create alert
            </v-btn>
            <v-btn
              v-else-if="this.method === 'edit'"
              slot="activator"
              id="btn-edit-submit"
              color="blue darken-3 font-weight-light"
              @click="editRule('edit')"
              style="outline: none;  text-transform: none; font-size: 16px; border-radius: 4px;"
            >
              <!-- <v-icon large>arrow_forward</v-icon> -->
              Create alert
            </v-btn>
            <!-- <v-btn slot="activator"  flat icon  @click.native="editalert=false">
              <v-icon>cancel</v-icon>
            </v-btn> -->
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- Dialog Create alert for management -->
    <v-layout>
        <v-dialog v-model="isDialogCreateAlert"
                    persistent
                    max-width="550px"
                    min-height="1050px">
            <v-card dark>
                <v-toolbar flat>
                    <v-toolbar-title>Create Alert For Management</v-toolbar-title>
                    <v-spacer />
                    <v-btn
                        icon
                        dark
                        style="outline: none;"
                        @click="isDialogCreateAlert = false"
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                  <v-autocomplete
                    v-model="instance_mn"
                    :items="instances_mn"
                    clearable
                    label="Instace"
                    placeholder="Select instace"
                  />
                  <v-autocomplete
                    v-model="username_mn"
                    :items="usernames_mn"
                    :disabled="instance_mn == ''"
                    clearable
                    label="Select Username"
                    required
                  />
                  <v-text-field
                    v-model="newAlertName"
                    :disabled="disable_mn"
                    label="Alert Name"
                    :rules="[v => !!v || 'Alert Name is required']"
                    required
                  />
                  <v-combobox
                    v-model="querytext"
                    :disabled="disable_mn"
                    label="Query by (e.g. facebook)"
                    chips
                    clearable
                    multiple
                    :rules="queryRule"
                  >
                    <template slot="selection" slot-scope="data">
                      <v-chip
                        :selected="data.selected"
                        close
                        @input="remove(data.item)"
                      >
                        <strong>{{ data.item }}</strong>&nbsp;
                      </v-chip>
                    </template>
                  </v-combobox>
                  <v-select
                    v-model="selectedIndex"
                    :disabled="disable_mn"
                    label="Device"
                    :items="deviceItem"
                    :rules="[v => !!v || 'Device is required']"
                  />
                  <v-flex xs12 sm12 d-flex>
                    <v-select
                      v-model="eventTrigger"
                      :disabled="disable_mn"
                      label="Event Type"
                      :items="eventType"
                      :rules="[v => !!v || 'Event Type is required']"
                    />
                  </v-flex>
                  <v-flex v-if="eventTrigger === 'count'" lg12 md12 xs12 sm12 d-flex>
                    <v-autocomplete
                      v-if="eventTrigger"
                      v-model="targetField"
                      :disabled="disable_mn"
                      :items="dashField"
                      :rules="[v => !!v || 'Select Field is required']"
                      label="Select Field To Use Alert"
                    />
                  </v-flex>
                  <v-flex xs12 sm12 d-flex v-if="eventTrigger === 'count'">
                    <v-select
                      v-model="alertTrigger"
                      :disabled="disable_mn"
                      label="Trigger Alert When"
                      :items="alertConditionOptions"
                      :rules="[v => !!v || 'Trigger Alert When is required']"
                    />
                    <v-text-field
                      v-model="number"
                      :disabled="disable_mn"
                      label="Number of Results"
                      type="Number"
                      :rules="rulesnumber"
                      required
                    />
                  </v-flex>
                  <v-flex lg12 md12 xs12 sm12 d-flex v-else-if="eventTrigger === 'upload' || eventTrigger === 'download'">
                    <v-select
                      v-model="fieldalet"
                      :disabled="disable_mn"
                      label="Select Field To Use Alert BW"
                      :items="dashField"
                      :rules="[v => !!v || 'Trigger Alert When is required']"
                    />
                  </v-flex>
                  <v-flex lg12 md12 xs12 sm12 d-flex v-if="fieldalet">
                    <v-flex lg5 md5>
                      <v-select
                        v-model="alertTrigger"
                        :disabled="disable_mn"
                        label="Trigger Alert When"
                        :items="alertConditionOptions"
                        :rules="[v => !!v || 'Trigger Alert When is required']"
                      />
                    </v-flex>
                    <v-text-field
                      v-model="number"
                      :disabled="disable_mn"
                      label="Number of Results"
                      :rules="rulesnumber"
                      type="Number"
                      required
                    />
                    <v-flex lg2 md2>
                      <v-select
                        v-model="unit"
                        :disabled="disable_mn"
                        label="Unit"
                        :items="units"
                        :rules="[v => !!v || 'Unit is required']"
                      />
                    </v-flex>
                  </v-flex>
                  <v-flex xs16 sm13 d-flex>
                    <v-select
                      v-model="alertInterval"
                      :disabled="disable_mn"
                      label="Unit"
                      :items="IntervalTime"
                      :rules="rulestime"
                    />
                    <v-select
                      v-model="intervals"
                      :disabled="disable_mn"
                      label="Run Every"
                      :items="alertFrequencyOptions"
                      :rules="[v => !!v || 'Run Every is required']"
                    />
                  </v-flex>
                  <v-flex xs16 sm13 d-flex>
                    <VueCtkDateTimePicker
                      v-if="alertInterval==='d'"
                      v-model="yourValue"
                      :disabled="disable_mn"
                      formatted="HH:mm"
                      format="HH:mm"
                      time-format="HH:mm"
                      label="Choose time"
                      :minute-interval="1"
                      disable-date
                      />
                  </v-flex>
                  <v-select
                    v-model="Action"
                    :disabled="disable_mn"
                    label="Action"
                    :items="ActionType"
                    :rules="[v => !!v || 'Action is required']"
                    required
                  />
                  <v-text-field
                    v-model="email"
                    :disabled="disable_mn"
                    label="Sent to (Email)"
                    :rules="[v => !!v || 'Email is required',
                            v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid']"
                    required
                  />
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        slot="activator"
                        class="white--text"
                        color="green darken-1"
                        depressed
                        style="outline: none;"
                        @click="confirmCreateAlert"
                    >
                        Save
                        <v-icon size="30" right>save</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
    <v-snackbar
      v-model="snackbar"
      :bottom="false"
      :left="false"
      :multi-line="true"
      :right="false"
      :timeout="6000"
      :top="true"
      :vertical="false"
    >
      {{ snackbartext }}
      <v-btn
        color="pink"
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-tour name="recommand-tour-al-condition" :steps="steps" :options="stepOptions" :callbacks="stepCallbacks">
      <template slot-scope="tour">
        <transition name="fade"></transition>
          <v-step
            v-if="tour.steps[tour.currentStep]"
            :key="tour.currentStep"
            :step="tour.steps[tour.currentStep]"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
            :highlight="tour.highlight"
            class="tour-body"
          >
            <template>
              <v-layout slot="header" class="tour-header">
                <img v-if="tour.currentStep == 0" src="../assets/img/login/logo-ilog-256.png" alt="ilog_logo" style="width: 21px; height: 21px; position: relative; top: 5px; left: 50px;">
                <v-icon v-if="tour.currentStep == 1" style="position: relative; left: 70px; color: #fff;">notifications_active</v-icon>
                <v-icon v-if="tour.currentStep == 2" style="position: relative; left: 75px; color: #fff;">add_alert</v-icon>
                <v-icon v-if="tour.currentStep == 3" style="position: relative; left: 75px; color: #fff;">settings</v-icon>
                <v-icon v-if="tour.currentStep == 4" style="position: relative; left: 130px; color: #fff;">build</v-icon>
                <v-icon v-if="tour.currentStep == 5" style="position: relative; left: 130px; color: #fff;">build</v-icon>
                <v-icon v-if="tour.currentStep == 6" style="position: relative; left: 110px; color: #fff;">chat</v-icon>
                <v-flex class="headline font-weight-light" v-html="tour.steps[tour.currentStep].header.title"></v-flex>
              </v-layout>
              <v-layout slot="content" class="tour-content" column>
                <v-flex class="body-2 font-weight-light" my-2>( {{tour.currentStep + 1}} / {{tour.steps.length}} )</v-flex>
                <v-flex class=" body-2 font-weight-light" v-html="tour.steps[tour.currentStep].content" ></v-flex>
              </v-layout>
              <v-layout slot="actions" fill-height align-center justify-center row>
                <v-flex v-if="tour.currentStep == 0" mt-2>
                  <v-btn @click="tour.nextStep" class="tour-btn-start font-weight-regular" block>Start</v-btn>
                  <button @click="tour.skip" class="tour-btn-skip">Skip</button>
                </v-flex>
                <v-flex v-else-if="!tour.isLast" column mt-3>
                  <v-btn @click="tour.previousStep" class="tour-btn-back font-weight-regular" round>Back</v-btn>
                  <v-btn @click="tour.nextStep" class="tour-btn-next font-weight-regular" round>Next</v-btn><br>
                  <button @click="tour.skip" class="tour-btn-skip">Skip</button>
                </v-flex>
                <v-flex v-else>
                  <v-btn @click="tour.finish" class="tour-btn-finish" block>Finish</v-btn>
                </v-flex>
              </v-layout>
            </template>
          </v-step>
      </template>
    </v-tour>
  </v-container>
</template>

<script>
  import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
  import axios from 'axios'
  import jwtDecode from 'jwt-decode'
  import cronstrue from 'cronstrue'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    name: 'alert',
    components: {
      VueCtkDateTimePicker,
      Loading
    },
    data () {
      return {
        // create alert for management
        isDialogCreateAlert: false,
        loadingBTN: false,
        disable_mn: true,
        allData_mn: [],
        username_mn: '',
        usernames_mn: [],
        instance_mn: '',
        instances_mn: [],
        tabMenu: [],
        tabIndex: 0,
        snackbar: false,
        snackbartext: 'test',
        device: 'All',
        devices: ['All'],
        rulesnumber: [
          (v) => !!v || 'Number is required',
          (v) => v >= 0 || 'Interval less than 0',
          (v) => v.length <= 7 || 'Name must be less than 7 characters'
        ],
        rulestime: [
          (v) => !!v || 'Unit is required'
          // (v) => v !== 'M' || '* month fixable At 12:00AM on day 1 of the month'
        ],
        queryRule: [
          (v) => {
            if (!v || v.length === 0) {
            return 'Query is required'
          } else return true
          }
        ],
        deletemode: false,
        editalert: false,
        setAlert: false,
        editAlertLoading: false,
        valid: true,
        yourValue: null,
        crontabInterval: '',
        intervals: '',
        alertInterval: '',
        ruleid: '',
        token: '',
        decoded: '',
        user_id: '',
        user_index: '',
        user_inst: '',
        deleuser: '',
        alert: [],
        errors: [],
        ActionType: [
          {
            text: 'Alert Email',
            value: 'Email'
          }
        ],
        eventType: [
          {
            text: 'Count',
            value: 'count'
          }
        ],
        fieldalet: '',
        eventTrigger: '',
        unit: '',
        units: [
          {
            text: 'GB',
            value: 'GB'
          },
          {
            text: 'MB',
            value: 'MB'
          },
          {
            text: 'KB',
            value: 'KB'
          }
        ],
        dashField: [],
        IntervalTime: [
          {
            text: 'minute',
            value: 'm'
          },
          {
            text: 'hour',
            value: 'h'
          },
          {
            text: 'day',
            value: 'd'
          },
          {
            text: 'month',
            value: 'M'
          }
        ],
        number: '',
        alertTrigger: '',
        targetField: '',
        newAlertName: '',
        Action: 'Email',
        email: '',
        typeAlert: '',
        selectedIndex: '',
        querytext: [],
        uID: '',
        method: '',
        deviceItem: [],
        header: '',
        search: '',
        pagination: {
          rowsPerPage: 10
        },
        selected: [],
        multiDelete: false,
        user: '',
        ampid: '',
        loadTable: false,
        recommend: false,
        stepOptions: {
          useKeyboardNavigation: true,
          highlight: true,
          labels: {
            buttonSkip: 'ข้าม',
            buttonPrevious: 'ย้อนกลับ',
            buttonNext: 'ต่อไป',
            buttonStop: 'สิ้นสุด'
          }
        },
        stepCallbacks: {
          onSkip: this.finishStepTour,
          onFinish: this.finishStepTour
        },
        steps: [
          {
            target: '#menu-condition',
            header: {
              title: 'Get Started with iLog 2.6'
            },
            content: `<h5>Alert condition ศูนย์รวมการจัดการแจ้งเตือน</h5><span>ที่จะรวมการตั้งค่าการแจ้งเตือนที่คุณได้ตั้งไว้<br>ทั้งในหมวด iLog และ PDPA ที่ช่วยให้คุณ<br>แก้ไขการตั้งค่าแจ้งเตือนได้ง่ายๆ ด้วยตัวคุณเอง</span>`,
            params: {
              highlight: false,
              enableScrolling: false
            },
            before: () => {
              this.alert = [
                {
                  _id: '60bf10524a91913248032d42',
                  action: 'Email',
                  alertid: '6065410b16611d589b45a508',
                  email: 'example@email.co.th',
                  eventTrigger: 'count',
                  fieldalet: '',
                  intervals: 'Every 10 minutes',
                  name: 'ผู้ที่เข้า social media ในเวลางาน',
                  query: 'text: facebook*',
                  raw_interval: '10  m',
                  selectedIndex: 'fortigate',
                  targetField: 'username',
                  trigger: 'Greater than  1',
                  unit: ''
                }
              ]
            }
          },
          {
            target: '#ex-data',
            header: {
              title: 'ตัวอย่างตั้งค่าแจ้งเตือน'
            },
            content: `<span>ที่รายงานเกี่ยวกับผู้ใช้งาน<br>ที่เข้าใช้ social media ในเวลาทำงาน</span>`,
            params: {
              highlight: true,
              enableScrolling: false
            }
          },
          {
            target: '#btn-createAl',
            header: {
              title: 'ปุ่มสร้างการแจ้งเตือน'
            },
            content: `<span>คุณสามารถกดสร้างการแจ้งเตือนได้ด้วยตัวคุณเอง <br>เพียงคลิก Create Alert</span>`,
            params: {
              highlight: true,
              enableScrolling: false
            },
            before: () => {
              this.editalert = false
            }
          },
          {
            target: '#btn-create-submit',
            header: {
              title: 'รายละเอียดการตั้งค่า'
            },
            content: `<span>กรอกรายละเอียดการตั้งค่าการแจ้งเตือนให้ครบถ้วน <br>แล้วกดบันทึก<br>(ดูรายละเอียดได้ที่ Manual)</span>`,
            params: {
              placement: 'right',
              highlight: true,
              enableScrolling: false
            },
            before: () => {
              let alertid = this.alert[0]
              let value = alertid.trigger.split('  ')
              let run = alertid.raw_interval.split('  ')
              this.$refs.form.reset()
              this.header = 'Add Alert'
              this.method = 'add'
              this.deviceItem = ['fortigate']
              this.newAlertName = alertid.name
              this.querytext.push(alertid.query)
              this.selectedIndex = alertid.selectedIndex
              this.eventTrigger = alertid.eventTrigger
              this.alertTrigger = value[0]
              this.targetField = alertid.targetField
              this.number = value[1]
              this.fieldalet = alertid.fieldalet
              this.alertInterval = run[1]
              this.intervals = parseInt(run[0])
              this.unit = alertid.unit
              // this.yourValue = `${(alertid.value.intervals).split(' ')[1]}:${(alertid.value.intervals).split(' ')[0]}`
              // this.Action = 'Email'
              this.email = alertid.email
              this.editalert = true
            }
          },
          {
            target: '#table-action',
            header: {
              title: 'การแก้ไข'
            },
            content: `<span>คุณสามารถ ลบ และแก้ไข้การตั้งค่า<br>เพียงคลิก Action</span>`,
            params: {
              placement: 'left',
              highlight: false,
              enableScrolling: true
            },
            before: () => {
              this.editalert = false
            }
          },
          {
            target: '#btn-edit-submit',
            header: {
              title: 'การแก้ไข'
            },
            content: `<span>คุณสามารถแก้ไขการตั้งค่าแจ้งเตือนได้ตามที่คุณต้องการ <br>จากนั้นกดบันทึก</span>`,
            params: {
              placement: 'right',
              highlight: false,
              enableScrolling: true
            },
            before: () => {
              this.geteditRule(this.alert[0])
            }
          },
          {
            target: '#menu-condition',
            header: {
              title: 'Support iLog'
            },
            content: `<span>หากคุณมีข้อสงสัยเพิ่มเติมสามารถคลิกที่ปุ่มเมนู Manual ที่แถบเมนู <br>หรือสามารถติดต่อหา Support iLog ได้ผ่านทุกช่องทาง</span>`,
            params: {
              highlight: false,
              enableScrolling: true
            },
            before: () => {
              this.editalert = false
            }
          }
        ]
      }
    },
    async created () {
      this.token = sessionStorage.getItem('user-token')
      this.decoded = jwtDecode(this.token)
      this.ampid = this.decoded.ampid
      this.user_id = this.decoded._id
      this.user_index = this.decoded.index
      this.user_inst = this.decoded.instance
      this.user = this.decoded.username
      this.role = this.decoded.role
      // if (this.user_index) {
      //   for (let element of this.user_index) {
      //     let object = {
      //       text: element,
      //       value: element
      //     }
      //     this.deviceItem.push(object)
      //   }
      // }
      this.role === 'management' ? this.getIndex('admin') : this.getIndex('user')
      this.getAlert()
      this.role === 'management'
        ? this.headers = [
          {
            text: 'Username',
            align: 'center',
            value: 'username'
          },
          {
            text: 'Alert name',
            align: 'center',
            value: 'name'
          },
          {
            text: 'Query',
            align: 'center',
            value: 'query'
          },
          {
            text: 'Selected Index',
            align: 'center',
            value: 'selectedIndex'
          },
          {
            text: 'TYPE',
            align: 'center',
            value: 'eventTrigger'
          },
          {
            text: 'Trigger',
            align: 'center',
            value: 'trigger'
          },
          {
            text: 'Interval',
            align: 'center',
            value: 'intervals'
          },
          {
            text: 'Action',
            align: 'center',
            value: 'action'
          },
          {
            text: 'Email',
            align: 'center',
            value: 'email'
          },
          {
            text: 'Actions',
            align: 'center',
            value: 'actions'
          }
        ]
        : this.headers = [
          {
            text: 'Alert name',
            align: 'center',
            value: 'name'
          },
          {
            text: 'Query',
            align: 'center',
            value: 'query'
          },
          {
            text: 'Selected Index',
            align: 'center',
            value: 'selectedIndex'
          },
          {
            text: 'TYPE',
            align: 'center',
            value: 'eventTrigger'
          },
          {
            text: 'Trigger',
            align: 'center',
            value: 'trigger'
          },
          {
            text: 'Interval',
            align: 'center',
            value: 'intervals'
          },
          {
            text: 'Action',
            align: 'center',
            value: 'action'
          },
          {
            text: 'Email',
            align: 'center',
            value: 'email'
          },
          {
            text: 'Actions',
            align: 'center',
            value: 'actions'
          }
        ]
      if (this.role === 'management') {
        this.tabMenu = ['iLog', 'PDPA', 'All']
        let result = await axios.post(apiUrl + '/api/query/getAllIndex', {
          id: this.user_id,
          command: 'admin'
        })
        this.deviceItem = result.data
      } else {
        let result
        if (this.decoded.pdpacontrol.dashboard) {
          this.tabMenu = ['iLog', 'PDPA']
          result = await axios.post(apiUrl + '/api/query/getAllIndex', {
            id: this.user_id,
            command: 'user'
          })
        } else {
          this.tabMenu = ['iLog']
          result = await axios.post(apiUrl + '/api/query/getAllIndex', {
            id: this.user_id,
            command: 'tcca'
          })
        }
        this.deviceItem = result.data
      }
      if (this.role === 'user') {
        let response = await axios.post(apiUrl + '/api/status/recommend', {
          command: 'get'
        })
        this.recommend = response.data.alertcondition
      }
    },
    computed: {
      alertConditionOptions: function () {
        if (this.eventTrigger === 'count') {
          return [
            { text: 'Greater than', value: 'Greater than' },
            { text: 'Equal to', value: 'equal to' },
            { text: 'Less than', value: 'less than' }
          ]
        }
        return [
          { text: 'Greater than', value: 'Greater than' }
        ]
      },
      alertFrequencyOptions: function () {
        let unit = this.alertInterval === 'm'
          ? 'Minute'
          : this.alertInterval === 'h'
          ? 'Hour'
          : this.alertInterval === 'd'
          ? 'Day'
          : 'Month'
        if (this.alertInterval) {
          let interval = {
            m: 59,
            h: 23,
            d: 31,
            M: 12
          }[this.alertInterval]
          return [...new Array(interval)].map((value, i) => ({text: `${i + 1} ${unit}`, value: i + 1}))
        }
        return []
      }
    },
    methods: {
      async getAlert () {
        this.loadTable = true
        // this.alert = []
        let response = await axios.post(apiUrl + '/api/query/getAlerts/' + this.user_id, {
          role: this.role
        })
        // let result
        let type = ''
        if (this.tabIndex === 0) {
          // result = await axios.post(apiUrl + '/api/query/getAllIndex', {
          //   id: this.user_id,
          //   command: 'tcca'
          // })
          type = 'tcca'
        } else if (this.tabIndex === 1) {
          // result = await axios.post(apiUrl + '/api/query/getAllIndex', {
          //   id: this.user_id,
          //   command: 'pdpa'
          // })
          type = 'pdpa'
          // result.data.push('pdpa')
        } else if (this.tabIndex === 2) {
          // result = await axios.post(apiUrl + '/api/query/getAllIndex', {
          //   id: this.user_id,
          //   command: 'admin'
          // })
          // result.data.push('pdpa')
          type = 'all'
        }
        // console.log(result.data)
        // console.log(response.data.alert)
        this.alert = response.data.alert
        let fillterAlert = []
        this.alert.map(el => {
            if (type === el.type) {
              if (el.intervals !== undefined) {
                el.intervals = cronstrue.toString(el.intervals)
                el.query = el.query.join(' , ')
              }
              fillterAlert.push(el)
            } else if (type === 'all') {
              if (el.intervals !== undefined) {
                el.intervals = cronstrue.toString(el.intervals)
                el.query = el.query.join(' , ')
              }
              fillterAlert.push(el)
            } else if (!el.type) {
              if (el.intervals !== undefined) {
                el.intervals = cronstrue.toString(el.intervals)
                el.query = el.query.join(' , ')
              }
              fillterAlert.push(el)
            }
            // if (result.data.find(item => item === el.selectedIndex) !== undefined) {
            //   if (el.intervals !== undefined) {
            //     el.intervals = cronstrue.toString(el.intervals)
            //     el.query = el.query.join(' , ')
            //   }
            //   fillterAlert.push(el)
            // }
        })
        // console.log('fillterAlert')
        // console.log(fillterAlert)
        this.loadTable = false
        this.alert = fillterAlert
      },
      customFilter (value, search) {
        if (this.device) {
          if (this.device !== 'All') {
              value = value.filter(el => el.selectedIndex === this.device)
          }
        }
        if (search !== '') {
          let regex = new RegExp(search)
          value = value.filter(el =>
            regex.test(el.username) ||
            regex.test(el.name) ||
            regex.test(el.query) ||
            regex.test(el.selectedIndex) ||
            regex.test(el.eventTrigger) ||
            regex.test(el.trigger) ||
            regex.test(el.intervals) ||
            regex.test(el.action) ||
            regex.test(el.email))
        }
        return value
      },
      async geteditRule (alertid) {
        window.analytics.track(`[AlertCondition][iLog][Action][edit]`, {}, {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
        })
        this.header = 'Edit Alert'
        this.uID = (this.role === 'management')
          ? alertid.usr_id
          : this.user_id
        this.ruleid = alertid._id
        this.method = 'edit'
        if (this.recommend) {
          this.deviceItem = ['fortigate']
          let value = alertid.trigger.split('  ')
          let run = alertid.raw_interval.split('  ')
          this.newAlertName = alertid.name
          this.querytext.push(alertid.query)
          this.selectedIndex = alertid.selectedIndex
          this.eventTrigger = alertid.eventTrigger
          this.alertTrigger = value[0]
          this.targetField = alertid.targetField
          this.number = value[1]
          this.fieldalet = alertid.fieldalet
          this.alertInterval = run[1]
          this.intervals = parseInt(run[0])
          this.unit = alertid.unit
          // this.yourValue = `${(alertid.value.intervals).split(' ')[1]}:${(alertid.value.intervals).split(' ')[0]}`
          this.Action = alertid.action
          this.email = alertid.email
          this.editalert = true
        } else {
          await axios.post(apiUrl + '/api/query/alert/' + this.uID, {
            alert_id: alertid._id
          }).then(response => {
            let data = response.data.value
            let value = data.trigger.split('  ')
            let run = data.raw_interval.split('  ')
            this.newAlertName = data.name
            this.querytext = data.query
            this.selectedIndex = data.selectedIndex
            this.eventTrigger = data.eventTrigger
            this.alertTrigger = value[0]
            this.targetField = data.targetField
            this.number = value[1]
            this.fieldalet = data.fieldalet
            this.alertInterval = run[1]
            this.intervals = parseInt(run[0])
            this.unit = data.unit
            this.yourValue = `${(response.data.value.intervals).split(' ')[1]}:${(response.data.value.intervals).split(' ')[0]}`
            this.Action = data.action
            this.email = data.email
            this.typeAlert = data.type
          })
          this.editalert = true
        }
        // await axios.post(apiUrl + '/api/query/alert/' + this.uID, {
        //   alert_id: alertid._id
        // }).then(response => {
        //   let data = response.data.value
        //   let value = data.trigger.split('  ')
        //   let run = data.raw_interval.split('  ')
        //   this.newAlertName = data.name
        //   this.querytext = data.query
        //   this.selectedIndex = data.selectedIndex
        //   this.eventTrigger = data.eventTrigger
        //   this.alertTrigger = value[0]
        //   this.targetField = data.targetField
        //   this.number = value[1]
        //   this.fieldalet = data.fieldalet
        //   this.alertInterval = run[1]
        //   this.intervals = parseInt(run[0])
        //   this.unit = data.unit
        //   this.yourValue = `${(response.data.value.intervals).split(' ')[1]}:${(response.data.value.intervals).split(' ')[0]}`
        //   this.Action = data.action
        //   this.email = data.email
        // })
        // this.editalert = true
      },
      remove (item) {
        this.querytext.splice(this.querytext.indexOf(item), 1)
        this.querytext = [...this.querytext]
      },
      async editRule (method) {
        let result = await axios.post(apiUrl + '/api/query/getAllIndex', {
          id: this.user_id,
          command: 'tcca'
        })
        if (result.data.find(item => item === this.selectedIndex)) {
          this.typeAlert = 'tcca'
        } else {
          this.typeAlert = 'pdpa'
        }
        if (this.$refs.form.validate()) {
          let queryFrom = []
          this.editAlertLoading = true
          let frequency = this.intervals
          let exactTime = this.yourValue
            ? this.yourValue.split(':')
            : ''
          for (let element of this.querytext) {
            if (element.includes(':')) {
              queryFrom.push(element)
            } else {
              queryFrom.push(`text: ${element}`)
            }
          }
          this.crontabInterval = exactTime
            ? {
                m: `*/${frequency} * * * *`,
                h: `0 */${frequency} * * *`,
                d: `${exactTime[1]} ${exactTime[0]} */${frequency} * *`,
                M: `0 0 1 */${frequency} *`
              }[this.alertInterval]
            : {
                m: `*/${frequency} * * * *`,
                h: `0 */${frequency} * * *`,
                M: `0 0 1 */${frequency} *`
              }[this.alertInterval]
          let request = {
            _id: this.ruleid,
            name: this.newAlertName,
            query: queryFrom,
            selectedIndex: this.selectedIndex,
            trigger: `${this.alertTrigger}  ${this.number * 1}`,
            number: this.number * 1,
            unit: this.unit,
            eventTrigger: this.eventTrigger,
            targetField: this.targetField,
            fieldalet: this.fieldalet,
            intervals: this.crontabInterval,
            raw_interval: `${this.intervals}  ${this.alertInterval}`,
            action: this.Action,
            email: this.email,
            user: this.decoded.username,
            type: this.typeAlert
          }
          let addrequest = {
            name: this.newAlertName,
            query: queryFrom,
            selectedIndex: this.selectedIndex,
            trigger: this.alertTrigger,
            number: this.number * 1,
            unit: this.unit,
            eventTrigger: this.eventTrigger,
            targetField: this.targetField,
            fieldalet: this.fieldalet,
            intervals: this.crontabInterval,
            alertInterval: this.alertInterval,
            setintervals: this.intervals,
            action: this.Action,
            email: this.email,
            type: this.typeAlert
          }
          if (method === 'edit') {
            window.analytics.track(`[AlertCondition][iLog][Action][edit][Summit]`, {
              value: {
                id: this.uID,
                name: request.name,
                index: request.selectedIndex
              }
            }, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
          } else if (method === 'test') {
            window.analytics.track(`[AlertCondition][iLog][CreateAlert][Test]`, {
              value: {
                id: this.user_id,
                name: addrequest.name,
                index: addrequest.selectedIndex
              }
            }, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
          } else {
            window.analytics.track(`[AlertCondition][iLog][CreateAlert][Submit]`, {
              value: {
                id: this.user_id,
                name: addrequest.name,
                index: addrequest.selectedIndex
              }
            }, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
          }
          try {
            let response = method === 'edit'
              ? await axios.put(apiUrl + '/api/query/updateAlerts/' + this.uID, request)
              : method === 'test'
              ? await axios.post(apiUrl + '/api/query/testAlert/' + this.user_id, addrequest)
              : await axios.put(apiUrl + '/api/query/setAlerts/' + this.user_id, addrequest)
            if (response) {
              if (method === 'test') {
                this.editalert = true
              } else {
                this.editalert = false
              }
              // alert(response.data.message)
              this.snackbartext = response.data.message
              this.snackbar = true
            }
            this.editAlertLoading = false
            // this.refresh()
            this.getAlert()
          } catch (error) {
            this.snackbartext = error
            this.snackbar = true
          }
        }
      },
      getiduser (alertid) {
        this.deleuser = alertid.usr_id
        this.ruleid = alertid._id
        this.deletemode = true
      },
      deleteRule (alertid) {
        window.analytics.track(`[AlertCondition][iLog][Action][Delete]`, {}, {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
        })
        if (this.role === 'management') {
          axios.post(apiUrl + '/api/query/deletealert/' + this.deleuser, {
            alert_id: this.ruleid,
            user: this.decoded.username
          }).then((result) => {
            // alert(result.data.message)
            this.snackbartext = result.data.message
            this.snackbar = true
            this.deletemode = false
            this.refresh()
          })
          .catch(e => {
            this.errors.push(e)
          })
        } else if (this.role === 'user') {
          axios.post(apiUrl + '/api/query/deletealert/' + this.user_id, {
            alert_id: this.ruleid,
            user: this.decoded.username
          }).then((result) => {
              this.alert.pop(this.ruleid)
              // alert(result.data.message)
              this.snackbartext = result.data.message
              this.snackbar = true
              this.deletemode = false
              this.refresh()
          })
          .catch(e => {
            this.errors.push(e)
          })
        }
      },
      addAlert () {
        window.analytics.track(`[AlertCondition][iLog][CreateAlert]`, {}, {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
        })
        this.$refs.form.reset()
        this.header = 'Add Alert'
        this.method = 'add'
        this.editalert = true
      },
      refresh () {
        axios.post(apiUrl + '/api/query/getAlerts/' + this.user_id, {
          role: this.role
        }).then(response => {
          this.alert = response.data.alert
          for (let i = 0; i < this.alert.length; i++) {
            if (this.alert[i].intervals !== undefined) {
              this.alert[i].intervals = cronstrue.toString(this.alert[i].intervals)
              this.alert[i].query = this.alert[i].query.join(' , ')
            }
            this.alert[i].trigger = this.alert[i].trigger + this.alert[i].unit
          }
        }).catch(e => {
          this.errors.push(e)
        })
      },
      toggleAll () {
        if (this.selected.length) this.selected = []
        else this.selected = this.alert.slice()
      },
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      deleteItem () {
        let SelectIdDelete = []
        let SelectIdUser = []
        let id_Alert
        let id_User
        let alertpattern = []
        if (this.role === 'user') {
          for (let element of this.selected) {
            id_Alert = element._id
            id_User = this.user_id
            SelectIdDelete.push(id_Alert)
          }
          let obj = {
            user_id: id_User,
            alert_id: SelectIdDelete
          }
          alertpattern.push(obj)
          console.log(alertpattern)
          axios.post(apiUrl + '/api/query/multiDeleteAlert', {
            data: alertpattern,
            role: this.role,
            user: this.decoded.username
          }).then((result) => {
            // alert(result.data.message)
            this.snackbartext = result.data.message
            this.snackbar = true
            this.multiDelete = false
            this.refresh()
          })
            this.multiDelete = false
        } else {
          for (let element of this.selected) {
            id_Alert = element._id
            id_User = element.usr_id
            SelectIdDelete.push(id_Alert)
            SelectIdUser.push(id_User)
          }
          let unique_array = SelectIdUser.filter(function (elem, index, self) {
            return index === self.indexOf(elem)
          })
          alertpattern.push({user_id: unique_array, alert_id: SelectIdDelete})
          axios.post(apiUrl + '/api/query/multiDeleteAlert', {
            data: alertpattern,
            role: this.role,
            user: this.decoded.username
          }).then((result) => {
            // alert(result.data.message)
            this.snackbartext = result.data.message
            this.snackbar = true
            // console.log(result)
            this.multiDelete = false
            this.refresh()
          })
            this.multiDelete = false
          // console.log(SelectIdDelete)
        }
      },
      async getIndex (e) {
        if (e === 'user') {
          // let response = await axios.post(apiUrl + '/api/query/getAllIndex', {
          //   command: 'user',
          //   id: this.user_id
          // })
          let response = await axios.post(apiUrl + '/api/query/getAllIndex', {
            id: this.user_id,
            command: 'tcca'
          })
          response.data.map(el => this.devices.push(el))
        } else if (e === 'admin') {
          let response = await axios.post(apiUrl + '/api/query/getAllIndex', {
            command: 'admin'
          })
          response.data.map(el => this.devices.push(el))
        }
      },
      async deleteSelectedAlert () {
        window.analytics.track(`[AlertCondition][iLog][Delete]`, {}, {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
        })
        if (this.role === 'user') {
          let alert = []
          if (this.selected.length > 0) {
            this.selected.map(item => {
              alert.push({
                id: item._id,
                username: this.user
              })
            })
          }
          await axios.post(apiUrl + '/api/query/deleteSettingAlert', alert)
          this.alert = []
          this.getAlert()
          this.selected = []
        } else if (this.role === 'management') {
          let alert = []
          if (this.selected.length > 0) {
            this.selected.map(item => {
              // console.log(item)
              alert.push({
                id: item._id,
                username: item.username
              })
            })
          }
          await axios.post(apiUrl + '/api/query/deleteSettingAlert', alert)
          this.alert = []
          this.getAlert()
          this.selected = []
        }
      },
      async createAlertForManagement () {
        this.loadingBTN = true
        this.username_mn = ''
        this.instance_mn = ''
        // this.$refs.form.reset()
        let result = await axios.post(apiUrl + '/api/query/getUserForAlertcondition', {
          command: 'getdata'
        })
        this.allData_mn = result.data
        if (this.allData_mn.length > 0) {
          this.allData_mn.map(item => {
            this.usernames_mn.push(item.username)
            this.instances_mn.push(item.instance)
          })
        }
        this.loadingBTN = false
        this.isDialogCreateAlert = true
      },
      async confirmCreateAlert () {
        if (this.$refs.form.validate()) {
          this.isDialogCreateAlert = false
          let queryFrom = []
          let frequency = this.intervals
          let exactTime = this.yourValue ? this.yourValue.split(':') : ''
          for (let element of this.querytext) {
            if (element.includes(':')) {
              queryFrom.push(element)
            } else {
              queryFrom.push(`text: ${element}`)
            }
          }
          this.crontabInterval = exactTime
            ? {
                m: `*/${frequency} * * * *`,
                h: `0 */${frequency} * * *`,
                d: `${exactTime[1]} ${exactTime[0]} */${frequency} * *`,
                M: `0 0 1 */${frequency} *`
              }[this.alertInterval]
            : {
                m: `*/${frequency} * * * *`,
                h: `0 */${frequency} * * *`,
                M: `0 0 1 */${frequency} *`
              }[this.alertInterval]
          let addrequest = {
            name: this.newAlertName,
            query: queryFrom,
            selectedIndex: this.selectedIndex,
            trigger: this.alertTrigger,
            number: this.number * 1,
            unit: this.unit,
            eventTrigger: this.eventTrigger,
            targetField: this.targetField,
            fieldalet: this.fieldalet,
            intervals: this.crontabInterval,
            alertInterval: this.alertInterval,
            setintervals: this.intervals,
            action: this.Action,
            email: this.email
          }
          await axios.post(apiUrl + '/api/query/getUserForAlertcondition', {
            command: 'adddata',
            username: this.username_mn,
            config: addrequest
          })
          this.getAlert()
          this.$refs.form.reset()
        }
      },
      async finishStepTour () {
        this.deletemode = false
        this.editalert = false
        this.deletemode = false
        this.recommend = false
        this.getAlert()
        await axios.post(apiUrl + '/api/status/recommend', {
          command: 'disalertcondition'
        })
      }
    },
    watch: {
      selectedIndex: async function (selectedIndex) {
        if (this.role === 'management') {
          this.user_inst = this.instance_mn
        }
        this.eventType = [
          {
            text: 'Count',
            value: 'count'
          }
        ]
        // this.editAlertLoading = true
        let field = []
        let response = await axios.post(apiUrl + '/api/query/allfield', {
          index: this.selectedIndex,
          instance: this.user_inst
        })
        if (response) {
          // this.editAlertLoading = false
          for (let [value, element] of response.data.entries()) {
            field = element === 'geoip'
              ? response.data.splice(value, 1, 'geoip.country_name')
              : response.data
          }
          this.dashField = field
          for (let findbyte of this.dashField) {
            // eslint-disable-next-line
            findbyte === 'bytes_in'
              ? this.eventType.push({
                  text: 'Download',
                  value: 'download'
                })
              : findbyte === 'bytes_out'
                ? this.eventType.push({
                    text: 'Upload',
                    value: 'upload'
                  })
              : this.eventType
          }
        }
      },
      tabIndex: async function () {
        if (this.tabIndex === 0) {
          window.analytics.track(`[AlertCondition][iLog]`, {}, {
              integrations: {
                  Amplitude: {
                  'session_id': this.ampid
                  }
              }
          })
          this.selected = []
          await axios.post(apiUrl + '/api/dashboard/stage', {
            type: 'menu',
            username: this.user,
            menu: 'alert Condition',
            submenu: this.tabMenu[this.tabIndex]
          })
          if (this.role !== 'management') {
            let response = await axios.post(apiUrl + '/api/query/getAllIndex', {
              id: this.user_id,
              command: 'tcca'
            })
            this.devices = ['All']
            response.data.map(el => this.devices.push(el))
          }
          this.getAlert()
        } else if (this.tabIndex === 1) {
          window.analytics.track(`[AlertCondition][PDPA]`, {}, {
              integrations: {
                  Amplitude: {
                  'session_id': this.ampid
                  }
              }
          })
          this.selected = []
          await axios.post(apiUrl + '/api/dashboard/stage', {
            type: 'menu',
            username: this.user,
            menu: 'alert Condition',
            submenu: this.tabMenu[this.tabIndex]
          })
          if (this.role !== 'management') {
            let response = await axios.post(apiUrl + '/api/query/getAllIndex', {
              id: this.user_id,
              command: 'pdpa'
            })
            this.devices = ['All']
            response.data.map(el => this.devices.push(el))
          }
          this.getAlert()
        } else if (this.tabIndex === 2) {
          window.analytics.track(`[AlertCondition][All]`, {}, {
              integrations: {
                  Amplitude: {
                  'session_id': this.ampid
                  }
              }
          })
          this.selected = []
          await axios.post(apiUrl + '/api/dashboard/stage', {
            type: 'menu',
            username: this.user,
            menu: 'alert Condition',
            submenu: this.tabMenu[this.tabIndex]
          })
          this.getAlert()
        }
      },
      recommend: function () {
        if (this.recommend && this.$router.history.current.name === 'alert') {
          setTimeout(() => {
            this.$tours['recommand-tour-al-condition'].start()
          }, 1000)
        }
      },
      username_mn: function () {
        if (this.allData_mn.length > 0) {
          let user_mn = this.allData_mn.find(item => item.username === this.username_mn)
          if (user_mn) {
            // this.instance_mn = user_mn.instance
            this.deviceItem = user_mn.index
            this.disable_mn = false
          } else {
            // this.instance_mn = ''
            this.disable_mn = true
          }
        }
      },
      instance_mn: function () {
        if (this.allData_mn.length > 0) {
          if (this.instance_mn) {
            this.usernames_mn = []
            this.allData_mn.find(item => {
              if (item.instance === this.instance_mn) {
                this.usernames_mn.push(item.username)
              }
            })
          } else {
            this.allData_mn.find(item => {
              this.usernames_mn.push(item.username)
            })
          }
        }
      },
      search: function () {
        window.analytics.track(`[AlertCondition][iLog][Search]`, {
            value: {
                keyword: this.search
            }
        }, {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
        })
      }
    }
  }
</script>

<style scoped>
.container-alert {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    margin-bottom: 60px;
}
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0,0,0,.8);
}
.tour-body {
  max-width: 900px !important;
  min-width: 450px !important;
  max-height: 300px !important;
  padding: 0 !important;
  margin: auto !important;
  background-color: #212121 !important;
}
.tour-btn-start {
  color: #fff !important;
  background-color: #009688 !important;
  box-shadow: none !important;
  border-radius: 13px !important;
  width: 260px !important;
  outline: none !important;
  margin: 0 auto !important;
  margin-top: 10px !important;
  text-transform: none !important;
  font-size: 16px !important;
}
.tour-btn-skip {
  position: relative !important;
  left: 190px !important;
  text-transform: none !important;
  outline: none !important;
  font-size: 13px !important;
  margin: 10px 0 !important;
  color: #616161 !important;
  text-decoration-line: underline !important;
  font-style: normal !important;
  font-weight: normal !important;
}
.tour-btn-back {
  margin:0 10px !important;
  color: #212121 !important;
  outline: none !important;
  background-color: #fff !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 13px !important;
}
.tour-btn-next {
  margin:0 10px;
  color: #fff !important;
  outline: none !important;
  background-color: #009688  !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 13px !important;
}
.tour-btn-finish {
  color: #fff !important;
  outline: none !important;
  background-color: #009688  !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 13px !important;
  width: 25px !important;
  margin: 20px auto;
}
.tour-header {
  border-bottom: 1px solid #BDBDBD !important;
  margin: 12px 30px !important;
  padding: 0 !important;
}
.tour-content {
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/alert.vue